import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareReelCardFitImageMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  reelCardFitImage?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type UpdateShareReelCardFitImageMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, appearance: { __typename?: 'AssetAggregateAppearance', reelCardFitImage: boolean } } | { __typename?: 'CollectionShare', id: string, appearance: { __typename?: 'AssetAggregateAppearance', reelCardFitImage: boolean } } | null } | null };


export const UpdateShareReelCardFitImage = /*#__PURE__*/ gql`
    mutation UpdateShareReelCardFitImage($shareId: ID!, $reelCardFitImage: Boolean) {
  updateShare(
    input: {shareId: $shareId, appearance: {reelCardFitImage: $reelCardFitImage}}
  ) {
    share {
      id
      ... on AssetAggregate {
        appearance {
          reelCardFitImage
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<UpdateShareReelCardFitImageMutation, UpdateShareReelCardFitImageMutationVariables>;

          

          export const useUpdateShareReelCardFitImageMutation = (options?:MutationHookOptions<UpdateShareReelCardFitImageMutation, UpdateShareReelCardFitImageMutationVariables>) => useMutation(UpdateShareReelCardFitImage, options);
          

          export type UpdateShareReelCardFitImageMutationOptions = MutationHookOptions<UpdateShareReelCardFitImageMutation, UpdateShareReelCardFitImageMutationVariables>;

          

          export type UpdateShareReelCardFitImageMutationResult = ReturnType<typeof useUpdateShareReelCardFitImageMutation>[1];

          
